import type { PlanNode, StepNode } from './types';

const collectSteps = (plan: PlanNode): StepNode[] => {
	return plan.steps.concat(plan.plans.flatMap(collectSteps));
};

export const collapseSingleStepPlan = (
	topLevelPlan: PlanNode | undefined,
): PlanNode | undefined => {
	if (!topLevelPlan) {
		return topLevelPlan;
	}

	const allSteps = collectSteps(topLevelPlan);
	const isSingleStep = allSteps.length === 1;
	const isSingleIntent = topLevelPlan.plans.length === 1;
	if (isSingleStep || isSingleIntent) {
		return {
			actionType: 'plan',
			id: topLevelPlan.id,
			payload: {
				...(topLevelPlan.plans[0] ?? topLevelPlan).payload,
				blastRadius: topLevelPlan.payload.blastRadius,
				summary: topLevelPlan.payload.summary,
			},
			plans: [],
			steps: allSteps,
		};
	}

	return topLevelPlan;
};
